<div class="live-executor-panel">
  <p-accordion [multiple]="true" [value]="['0', '1']">
    <!-- Test Execution Section -->
    <p-accordion-panel value="0">
      <p-accordion-header>
        <div class="accordion-header-content">
          <i class="pi pi-play-circle"></i>
          <span class="accordion-title">Test Execution</span>
          <button 
            pButton 
            icon="pi pi-trash" 
            class="p-button-sm p-button-text clear-history-btn" 
            (click)="clearHistory(); $event.stopPropagation()"
            title="Clear history">
          </button>
        </div>
      </p-accordion-header>
      <p-accordion-content>

  <!-- Multi-Step Scenario Input -->
  <div class="step-input-section">
    <div class="section-header">
      <label>Test Scenario (one step per line):</label>
      <div class="header-actions">
        <button 
          pButton 
          [icon]="showResolvedValues ? 'pi pi-eye-slash' : 'pi pi-eye'"
          class="p-button-sm p-button-text p-button-rounded"
          (click)="toggleViewMode()"
          [title]="showResolvedValues ? 'Show placeholders (templates)' : 'Show resolved values'">
        </button>
        <p-checkbox [(ngModel)]="stopOnFailure" label="Stop on first failure" binary="true"></p-checkbox>
      </div>
    </div>
    <textarea 
      [(ngModel)]="stepInputText" 
      [readonly]="readOnlyMode"
      placeholder="Enter test steps (one per line):

Example:
Enter stud_isu in username textbox
Enter Test@123 in password textbox
Click Sign In button
Wait 3 seconds
Click Integration IDs
Enter pro of stud in Business Object field
Press Enter Key
Wait 2 seconds
Select Program of Study option
Click OK button
Verify table has 85 items across all pages
Verify Instance column has Violin Program Concentration across all pages

Verify page contains Allow Target Override
Verify Allow Target Override contains Yes

# Use # for comments
# For dropdowns: Type → Press Enter → Wait → Select option → Click OK
# Add 'across all pages' to search through pagination
# Supported: Enter, Click, Select, Wait, Navigate, Verify, Press Enter Key"
      rows="12"
      class="step-input"
      [class.readonly-textarea]="readOnlyMode">
    </textarea>
    <div class="input-actions">
      <div class="action-buttons">
        <button 
          pButton 
          label="Execute Single Step" 
          icon="pi pi-play" 
          class="p-button-sm p-button-outlined"
          (click)="executeSingleStep()"
          [disabled]="!hasStepInput || isExecuting">
        </button>
        <button 
          pButton 
          label="Run All Steps" 
          icon="pi pi-play-circle" 
          class="p-button-success p-button-sm"
          (click)="executeAllSteps()"
          [disabled]="!hasStepInput || isExecuting">
        </button>
        <button 
          pButton 
          label="Stop" 
          icon="pi pi-stop" 
          class="p-button-danger p-button-sm"
          (click)="stopExecution()"
          [disabled]="!isExecuting">
        </button>
      </div>
      <div class="hint-text">
        <!-- <span class="hint" *ngIf="!isExecuting">Ctrl+Enter to execute single step</span> -->
        <span class="hint" *ngIf="!readOnlyMode">**Save steps to track results**</span>
        <span class="hint running" *ngIf="isExecuting">
          Executing step {{ currentStepIndex + 1 }} of {{ totalSteps }}...
        </span>
      </div>
    </div>
  </div>

  <!-- Examples - Hidden in read-only mode -->
  <div class="examples-section" *ngIf="!readOnlyMode" style="display: none;">
    <details>
      <summary>Show Examples</summary>
      <div class="example-list">
        <div class="example-item" *ngFor="let example of examples" (click)="useExample(example)">
          <code>{{ example }}</code>
        </div>
      </div>
    </details>
  </div>

  <!-- Scenario Progress -->
  <div class="scenario-progress" *ngIf="scenarioReport">
    <h4>Scenario Summary</h4>
    <div class="summary-badges">
      <span class="badge badge-total">{{ scenarioReport.totalSteps }} Total</span>
      <span class="badge badge-success">{{ scenarioReport.passed }} Passed</span>
      <span class="badge badge-error">{{ scenarioReport.failed }} Failed</span>
      <span class="badge badge-warning" *ngIf="scenarioReport.stopped > 0">{{ scenarioReport.stopped }} Stopped</span>
      <span class="badge badge-duration">{{ scenarioReport.duration }}ms</span>
    </div>
  </div>
    </p-accordion-content>
    </p-accordion-panel>

    <!-- Execution History Section -->
    <p-accordion-panel value="1" style="padding-top: 1rem;">
      <p-accordion-header>
        <div class="accordion-header-content">
          <i class="pi pi-history"></i>
          <span class="accordion-title">Execution History</span>
        </div>
      </p-accordion-header>
      <p-accordion-content>
    <div class="history-list">
      <div 
        *ngFor="let execution of executionHistory; let i = index" 
        class="execution-item"
        [class.success]="execution.status === 'success'"
        [class.failed]="execution.status === 'failed'"
        [class.running]="execution.status === 'running'"
        [class.stopped]="execution.status === 'stopped'">
        
        <div class="execution-header">
          <span class="step-number">{{ i + 1 }}</span>
          <span class="step-action">{{ execution.step.action }}</span>
          <span class="status-icon">
            <i *ngIf="execution.status === 'success'" class="pi pi-check-circle"></i>
            <i *ngIf="execution.status === 'failed'" class="pi pi-times-circle"></i>
            <i *ngIf="execution.status === 'running'" class="pi pi-spin pi-spinner"></i>
            <i *ngIf="execution.status === 'stopped'" class="pi pi-minus-circle"></i>
          </span>
          <span class="duration" *ngIf="execution.result?.duration">
            {{ execution.result.duration }}ms
          </span>
        </div>

        <div class="step-description">
          {{ execution.step.description || getStepDescription(execution.step) }}
        </div>

        <div class="execution-details" *ngIf="execution.result">
          <!-- Enhanced Table Column Validation Display -->
          <div *ngIf="execution.result.success && execution.result.result?.assertion?.type === 'table-column-complete-validation'" 
               class="result-success validation-result">
            <div class="validation-summary" 
                 [class.validation-passed]="execution.result.result.assertion.passed"
                 [class.validation-failed]="!execution.result.result.assertion.passed">
              <strong>{{ execution.result.result.assertion.validationStatus }}</strong>
            </div>
            
            <div class="validation-details">
              <div class="detail-row">
                <span class="detail-label">Column:</span>
                <span class="detail-value">{{ execution.result.result.assertion.column }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Expected Value:</span>
                <span class="detail-value">{{ execution.result.result.assertion.expected }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Total Validated:</span>
                <span class="detail-value">{{ execution.result.result.assertion.totalValidated }} rows</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Matched:</span>
                <span class="detail-value" 
                      [class.text-success]="execution.result.result.assertion.totalMatched === true"
                      [class.text-danger]="execution.result.result.assertion.totalMatched === false">
                  {{ execution.result.result.assertion.totalMatched ? 'True' : 'False' }}
                </span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Pages Searched:</span>
                <span class="detail-value">{{ execution.result.result.assertion.pagesSearched }}</span>
              </div>
            </div>
            
            <!-- REMOVED: Mismatch details section for speed -->
            
            <div *ngIf="execution.result.result.assertion.warning" class="validation-warning">
              <i class="pi pi-exclamation-triangle"></i> {{ execution.result.result.assertion.warning }}
            </div>
          </div>
          
          <!-- Legacy Table Column Validation Display (backward compatible) -->
          <div *ngIf="execution.result.success && execution.result.result?.assertion?.type === 'table-column'" 
               class="result-success">
            <div class="validation-summary">
              <strong>Table Column Validation:</strong> 
              <span [class.text-success]="execution.result.result.assertion.passed"
                    [class.text-danger]="!execution.result.result.assertion.passed">
                {{ execution.result.result.assertion.passed ? 'PASSED' : 'FAILED' }}
              </span>
            </div>
            <div class="validation-details">
              <div>Column: {{ execution.result.result.assertion.column }}</div>
              <div>Expected: {{ execution.result.result.assertion.expected }}</div>
              <div>Pages Searched: {{ execution.result.result.assertion.pagesSearched }}</div>
              <div *ngIf="execution.result.result.assertion.rowsSearched">
                Rows Searched: {{ execution.result.result.assertion.rowsSearched }}
              </div>
              <div *ngIf="execution.result.result.assertion.foundOnPage">
                Found on Page: {{ execution.result.result.assertion.foundOnPage }}
              </div>
              <div *ngIf="execution.result.result.assertion.warning" class="validation-warning">
                <i class="pi pi-exclamation-triangle"></i> {{ execution.result.result.assertion.warning }}
              </div>
            </div>
          </div>

          <!-- Multi-Column Table Validation Display (Simple True/False like single-column) -->
          <div *ngIf="execution.result.success && execution.result.result?.assertion?.type === 'table-multi-column-validation'" 
               class="result-success table-validation-result">
            <div class="validation-header">
              <div class="validation-title">
                <strong>Multi-Column Table Validation</strong>
              </div>
              <div class="validation-columns">
                <span class="validation-label">Columns:</span>
                <span class="validation-value">{{ execution.result.result.assertion.columns }}</span>
              </div>
            </div>
            
            <div class="validation-details">
              <div class="detail-row">
                <span class="detail-label">Total Rows Validated:</span>
                <span class="detail-value">{{ execution.result.result.assertion.totalRows }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Matching Rows:</span>
                <span class="detail-value" [class.text-success]="execution.result.result.assertion.matchedRows === execution.result.result.assertion.totalRows"
                      [class.text-warning]="execution.result.result.assertion.matchedRows < execution.result.result.assertion.totalRows">
                  {{ execution.result.result.assertion.matchedRows }} 
                  ({{ execution.result.result.assertion.totalRows > 0 ? (execution.result.result.assertion.matchedRows / execution.result.result.assertion.totalRows * 100) : 0 | number:'1.1-1' }}%)
                </span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Pages Searched:</span>
                <span class="detail-value">{{ execution.result.result.assertion.pagesSearched }}</span>
              </div>
            </div>

            <!-- Simple True/False Result -->
            <div class="validation-result-display">
              <div class="result-banner" 
                   [class.result-true]="execution.result.result.assertion.result === 'True'"
                   [class.result-false]="execution.result.result.assertion.result === 'False'">
                <i [class.pi-check-circle]="execution.result.result.assertion.result === 'True'"
                   [class.pi-times-circle]="execution.result.result.assertion.result === 'False'"></i>
                <span class="result-text">{{ execution.result.result.assertion.result }}</span>
              </div>
            </div>
          </div>
          
          <!-- Page Content Verification Display -->
          <div *ngIf="execution.result.success && execution.result.result?.assertion?.type === 'page-content'" 
               class="result-success verification-result">
            <div class="verification-header" 
                 [class.verification-passed]="execution.result.result.assertion.passed"
                 [class.verification-failed]="!execution.result.result.assertion.passed">
              <i [class.pi-check-circle]="execution.result.result.assertion.passed"
                 [class.pi-times-circle]="!execution.result.result.assertion.passed"
                 class="pi"></i>
              <strong>{{ execution.result.result.assertion.message }}</strong>
            </div>
            <div class="verification-details">
              <div class="detail-row">
                <span class="detail-label">Searched For:</span>
                <span class="detail-value">"{{ execution.result.result.assertion.expected }}"</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Status:</span>
                <span class="detail-value" 
                      [class.text-success]="execution.result.result.assertion.passed"
                      [class.text-danger]="!execution.result.result.assertion.passed">
                  {{ execution.result.result.assertion.passed ? 'PASSED ✓' : 'FAILED ✗' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Page Title Verification Display -->
          <div *ngIf="execution.result.success && execution.result.result?.assertion?.type === 'page-title'" 
               class="result-success verification-result">
            <div class="verification-header" 
                 [class.verification-passed]="execution.result.result.assertion.passed"
                 [class.verification-failed]="!execution.result.result.assertion.passed">
              <i [class.pi-check-circle]="execution.result.result.assertion.passed"
                 [class.pi-times-circle]="!execution.result.result.assertion.passed"
                 class="pi"></i>
              <strong>Page Title Verification</strong>
            </div>
            <div class="verification-details">
              <div class="detail-row">
                <span class="detail-label">Expected:</span>
                <span class="detail-value">"{{ execution.result.result.assertion.expected }}"</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Actual Title:</span>
                <span class="detail-value">"{{ execution.result.result.assertion.actual }}"</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Status:</span>
                <span class="detail-value" 
                      [class.text-success]="execution.result.result.assertion.passed"
                      [class.text-danger]="!execution.result.result.assertion.passed">
                  {{ execution.result.result.assertion.passed ? 'PASSED' : 'FAILED' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Element Verification Display (for "Verify element contains value" commands) -->
          <div *ngIf="execution.result.success && execution.result.result?.assertion?.type === 'element-verification'" 
               class="result-success verification-result">
            <div class="verification-header" 
                 [class.verification-passed]="execution.result.result.assertion.passed"
                 [class.verification-failed]="!execution.result.result.assertion.passed">
              <i [class.pi-check-circle]="execution.result.result.assertion.passed"
                 [class.pi-times-circle]="!execution.result.result.assertion.passed"
                 class="pi"></i>
              <strong>{{ execution.result.result.assertion.message }}</strong>
            </div>
            <div class="verification-details">
              <div class="detail-row" *ngIf="execution.result.result.assertion.labelText">
                <span class="detail-label">Field Label:</span>
                <span class="detail-value">"{{ execution.result.result.assertion.labelText }}"</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Actual Value in Field:</span>
                <span class="detail-value field-value">"{{ execution.result.result.assertion.foundValue || execution.result.result.assertion.actual }}"</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Searched For:</span>
                <span class="detail-value search-value">"{{ execution.result.result.assertion.searchedFor || execution.result.result.assertion.expected }}"</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Status:</span>
                <span class="detail-value" 
                      [class.text-success]="execution.result.result.assertion.passed"
                      [class.text-danger]="!execution.result.result.assertion.passed">
                  {{ execution.result.result.assertion.passed ? 'PASSED ✓' : 'FAILED ✗' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Other Success Results (only for non-assertion results) -->
          <div *ngIf="execution.result.success && execution.result.result && 
                      !execution.result.result.assertion && 
                      !execution.result.error" 
               class="result-success">
            <strong>Result:</strong>
            <pre>{{ execution.result.result | json }}</pre>
          </div>
          
          <!-- Error Display for Failed Assertions -->
          <div *ngIf="!execution.result.success && execution.result.error && execution.result.error.includes('Assertion failed')" 
               class="verification-result result-error-formatted">
            <div class="verification-header verification-failed">
              <i class="pi pi-times-circle"></i>
              <strong>❌ Assertion Failed</strong>
            </div>
            <div class="verification-details">
              <div class="detail-row">
                <span class="detail-label">Error Details:</span>
                <span class="detail-value text-danger">{{ execution.result.error }}</span>
              </div>
            </div>
          </div>
          
          <!-- Error Display for Other Errors -->
          <div *ngIf="!execution.result.success && execution.result.error && !execution.result.error.includes('Assertion failed')" 
               class="result-error">
            <strong>Error:</strong> {{ execution.result.error }}
          </div>
          
          <!-- Legacy Error Display (fallback) -->
          <div *ngIf="execution.result.success && execution.result.error" class="result-error">
            <strong>Warning:</strong> {{ execution.result.error }}
          </div>
        </div>
      </div>

      <div *ngIf="executionHistory.length === 0" class="empty-state">
        <i class="pi pi-info-circle"></i>
        <p>No steps executed yet. Enter a test step above to begin.</p>
      </div>
    </div>
    </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <!-- Page State Info -->
  <div class="page-state-section"  style="display: none;">
    <button 
      pButton 
      label="Get Page State" 
      icon="pi pi-refresh" 
      class="p-button-sm p-button-outlined"
      (click)="getPageState()">
    </button>
    <div *ngIf="pageState" class="page-state-info">
      <div><strong>URL:</strong> {{ pageState.url }}</div>
      <div><strong>Title:</strong> {{ pageState.title }}</div>
      <div><strong>Ready:</strong> {{ pageState.readyState }}</div>
    </div>
  </div>

  <!-- Element Map Viewer -->
  <div class="element-map-section" style="display: none;">
    <button 
      pButton 
      label="Show Available Elements" 
      icon="pi pi-list" 
      class="p-button-sm p-button-outlined"
      (click)="toggleElementMap()">
    </button>
    <div *ngIf="showElementMap && elementMap.length > 0" class="element-map-list">
      <h5>{{ elementMap.length }} Interactive Elements Found:</h5>
      <div class="element-item" *ngFor="let elem of elementMap.slice(0, 20); let i = index">
        <div class="element-index">{{ i + 1 }}</div>
        <div class="element-details">
          <div class="element-type">{{ elem.type }}</div>
          <div class="element-identifiers">
            <span *ngFor="let id of elem.identifiers.slice(0, 3)" class="identifier">{{ id }}</span>
          </div>
        </div>
        <button 
          pButton 
          icon="pi pi-copy" 
          class="p-button-sm p-button-text"
          (click)="useIdentifier(elem.identifiers[0])"
          title="Use this identifier">
        </button>
      </div>
    </div>
  </div>
</div>
